import { createSlice } from "@reduxjs/toolkit";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const qualityCpmSlice = createSlice({
  name: "qualityCpm",
  initialState: {
    apiLoading: {
      kpi: false,
      trendArea: false,
    },
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    strategicRiskKPIData: {
      "QUALITY RISK SCORE": {
          "MoM": 100,
          "QoQ": 100,
          "value": 0.42
      },
      "COMPLAINTS PER MILLION LBS(CPM)": {
          "MoM": -286.2,
          "QoQ": -285.26,
          "value": 0.189
      }
    },
    trendAreaData: [],
    resetTriggered: false,
    complaintDetailsResetTriggered: false,
    tableData: [],
    prevTableData: [],
    qualityComplaintsByDate: [],
    qualityComplaintsByProduct: [],
    qualityComplaintsByLocation: [],
    prevQualityComplaintsByProduct: [],
    prevQualityComplaintsByLocation: [],
    qualityComplaintsByIncidentType: [],
    qualityComplaintsByIssueType: [],
    detailsTableData: [],
    detailsTableTotalPages: 0,
    detailsTableTotalRecords: 0
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setHeaderData(state, action) {
      state.headerData = action.payload;
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
    setComplaintDetailsResetTriggered(state, action) {
      state.complaintDetailsResetTriggered = action.payload;
    },
    setQualityRiskKPIData(state, action) {
      state.qualityRiskKPIData = action.payload;
    },
    setTrendAreaData(state, action) {
      state.trendAreaData = action.payload;
    },
    setQualityComplaintsByDate(state, action) {
      state.qualityComplaintsByDate = action.payload;
    },
    setTableData(state, action) {
      state.tableData = action.payload;
    },
    setPrevTableData(state, action) {
      state.prevTableData = action.payload;
    },
    setQualityComplaintsByProduct(state, action) {
      state.qualityComplaintsByProduct = action.payload;
    },
    setPrevQualityComplaintsByProduct(state, action) {
      state.prevQualityComplaintsByProduct = action.payload;
    },
    setQualityComplaintsByLocation(state, action) {
      state.qualityComplaintsByLocation = action.payload;
    },
    setPrevQualityComplaintsByLocation(state, action) {
      state.prevQualityComplaintsByLocation = action.payload;
    },
    setQualityComplaintsByIncidentType(state, action) {
      state.qualityComplaintsByIncidentType = action.payload;
    },
    setQualityComplaintsByIssueType(state, action) {
      state.qualityComplaintsByIssueType = action.payload;
    },
    setDetailsTableData(state, action) {
      state.detailsTableData = action.payload;
    },
    setDetailsTableTotalPages(state, action) {
      state.detailsTableTotalPages = action.payload;
    },
    setDetailsTableTotalRecords(state, action) {
      state.detailsTableTotalRecords = action.payload;
    }
  },
});

export const {
  setLoader,
  setHeaderData,
  setResetTriggered,
  setComplaintDetailsResetTriggered,
  setFilters,
  setQualityRiskKPIData,
  setTrendAreaData,
  setTableData,
  setPrevTableData,
  setQualityComplaintsByDate,
  setQualityComplaintsByProduct,
  setQualityComplaintsByLocation,
  setPrevQualityComplaintsByProduct,
  setPrevQualityComplaintsByLocation,
  setQualityComplaintsByIncidentType,
  setQualityComplaintsByIssueType,
  setDetailsTableData,
  setDetailsTableTotalPages,
  setDetailsTableTotalRecords
} = qualityCpmSlice.actions;

export default qualityCpmSlice.reducer;
